// Хук для OAuth аутентификации (Google, Apple)
import { type UseMutationResult } from '@tanstack/react-query';
import { supabase } from '@/lib';
import { useMutationWithCache } from '@/hooks';
import type { SocialProvider } from '@/features/user';

async function signInWithProvider(provider: SocialProvider): Promise<void> {
  const { error } = await supabase.auth.signInWithOAuth({
    provider,
    options: {
      redirectTo: window.location.origin,
    },
  });

  if (error) {
    throw new Error(error.message);
  }
}

export function useSocialAuth(): UseMutationResult<void, Error, SocialProvider, unknown> {
  return useMutationWithCache({
    mutationFn: signInWithProvider,
  });
}